import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  ConfirmSyncEnergyPerformanceCertificateInput,
  ConfirmSyncEnergyPerformanceCertificateMutation,
} from '@/gql/graphql';

const CONFIRM_SYNC_ENERGY_PERFORMANCE_CERTIFICATE_MUTATION = graphql(`
  mutation ConfirmSyncEnergyPerformanceCertificate(
    $input: ConfirmSyncEnergyPerformanceCertificateInput!
  ) {
    confirmSyncEnergyPerformanceCertificate(input: $input) {
      certificate {
        ...CertificateFields
      }
    }
  }
`);

type ConfirmSyncEnergyPerformanceCertificateResponse =
  ConfirmSyncEnergyPerformanceCertificateMutation['confirmSyncEnergyPerformanceCertificate'];

const useConfirmSyncEnergyPerformanceCertificate = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    ConfirmSyncEnergyPerformanceCertificateMutation,
    unknown,
    ConfirmSyncEnergyPerformanceCertificateInput
  >;
}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(
        CONFIRM_SYNC_ENERGY_PERFORMANCE_CERTIFICATE_MUTATION,
        { input }
      );
    },
    onSuccess: () => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.overview(args.projectId),
        });
        void queryClient.invalidateQueries({
          queryKey: projectKeys.heatLossEstimate(args.projectId),
        });
      }
    },
    ...args?.options,
  });
};

export default useConfirmSyncEnergyPerformanceCertificate;
